/**
 * Convert triage answers to decision score
 * @param {number[]} answers - Array of 6 answers (0-2 each)
 * @returns {number} Total score (0-12)
 */
export function triageToDecisionScore(answers) {
  return answers.reduce((sum, score) => sum + score, 0);
}

/**
 * Convert score to curriculum path
 * @param {number} score - Total triage score
 * @returns {"NC_WITH_SUPPORTS" | "BESPOKE" | "EITHER"}
 */
export function scoreToPath(score) {
  if (score <= 4) return "NC_WITH_SUPPORTS";
  if (score >= 7) return "BESPOKE";
  return "EITHER";
}

/**
 * Generate rationale based on highest scoring items
 * @param {number[]} answers - Array of 6 answers
 * @param {string[]} questions - Array of 6 questions
 * @returns {string} Rationale text
 */
export function generateRationale(answers, questions) {
  // Find the two highest scoring items
  const scoredItems = answers.map((score, index) => ({ score, question: questions[index] }));
  scoredItems.sort((a, b) => b.score - a.score);
  
  const topTwo = scoredItems.slice(0, 2);
  
  if (topTwo.length === 0) {
    return "Insufficient data to generate rationale.";
  }
  
  const questionNames = topTwo.map(item => {
    const questionText = item.question.toLowerCase();
    if (questionText.includes('attainment')) return 'Attainment';
    if (questionText.includes('participation')) return 'Participation';
    if (questionText.includes('communication')) return 'Communication';
    if (questionText.includes('regulation')) return 'Regulation';
    if (questionText.includes('ehcp')) return 'EHCP evidence';
    if (questionText.includes('independence')) return 'Independence';
    return 'Key indicators';
  });
  
  const totalScore = topTwo.reduce((sum, item) => sum + item.score, 0);
  
  if (totalScore >= 4) {
    return `${questionNames.join(' and ')} indicators suggest bespoke curriculum.`;
  } else {
    return `${questionNames.join(' and ')} indicators suggest national curriculum with supports.`;
  }
}

export const TRIAGE_QUESTIONS = [
  "Attainment vs age expectations",
  "Functional participation without 1:1",
  "Communication profile",
  "Regulation & attention span",
  "Evidence from EHCP/Reports about NC access",
  "Independence in core skills"
];

export const TRIAGE_OPTIONS = [
  { value: 0, label: "Significant challenges", description: "Requires substantial support" },
  { value: 1, label: "Moderate challenges", description: "Some support needed" },
  { value: 2, label: "Minimal challenges", description: "Can access with minor adjustments" }
];



